import MenuGeoMarketing from "../MenuGeoMarketing";
import Footer from "../Footer";
import NavbarTop from "../NavbarTop";
import MenuInicioRapido from "../MenuInicioRapido";
import React, { useEffect, useState } from "react";
import PesquisaArtigo from "../PesquisaArtigo";

export default function HowPublicoPotencial() {
  const [showScrollButton, setShowScrollButton] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    const checkScrollTop = () => {
      if (!showScrollButton && window.pageYOffset > 400) {
        setShowScrollButton(true);
      } else if (showScrollButton && window.pageYOffset <= 400) {
        setShowScrollButton(false);
      }
    };

    window.addEventListener("scroll", checkScrollTop);

    return () => {
      window.removeEventListener("scroll", checkScrollTop);
    };
  }, [showScrollButton]);

  useEffect(() => {
    // Rola a página para o topo sempre que a página é carregada
    window.scrollTo(0, 0);
  }, []); // Executa o efeito apenas uma vez, quando o componente é montado

  return (
    <>
      <section>
        <div>
          <NavbarTop />
        </div>

        <div className="container col-md-11">
          <div className="row content section paddingt-2 white-background">
            <div className="col-md-12">
              <nav aria-label="breadcrumb" role="navigation">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="/">Home</a>
                  </li>
                  <li className="breadcrumb-item">
                    <a href="/geomarketing">GeoMarketing</a>
                  </li>
                  <li className="breadcrumb-item active">
                    Como criar um Público Potencial?
                  </li>
                </ol>
              </nav>
            </div>
          </div>

          <div className="row justify-content-between">
            <div className="col-md-3 text-left d-none d-md-inline-block">
              <MenuGeoMarketing />
            </div>

            <div className="col-md-6">
              <h1 className="article-heading">
                Como criar um Público Potencial?
              </h1>
              <hr />

              <div className="row justify-content-between" id="article-meta">
                <div className="author col-6 pl-5">
                  <span className="author-name">GeoMarketing</span>
                </div>
                <small className="col-6 text-right pr-5">Público Alvo</small>
              </div>
              <hr />

              <div className="content article-content">
                <br></br>

                <p>
                  O desenvolvimento do seu público está no módulo 'Meu Público
                  Potencial' e por meio de um critério geográfico, especifique
                  em qual região você pretende explorar o seu público.
                </p>

                <p>
                  Selecione um endereço como ponto do seu raio de atuação e
                  depois o tamanho do seu raio de análise, estes campos são
                  obrigatórios:
                </p>

                <figure>
                  <img src="img/mapa-1.png" alt="excel" />
                </figure>

                <figcaption>Inserindo Endereço</figcaption>

                <p>
                  Defina ao menos um critério do seu público potencial. Você
                  pode utilizar
                  <a> </a>
                  <a href="/variaveis-demograficas" target="blank">
                    variáveis demográficas
                  </a>
                  ,<a> </a>
                  <a href="/variaveis-psicograficas" target="blank">
                    variáveis psicográficas
                  </a>{" "}
                  ou
                  <a> </a>
                  <a href="/variaveis-financeiras" target="blank">
                    variáveis financeiras
                  </a>
                  .
                </p>

                <figure>
                  <img src="img/publico2.png" alt="excel" />
                </figure>

                <figcaption>Filtro Renda</figcaption>

                <p>
                  Selecione qualquer uma das condições, em seguida o valor
                  desejado. Exemplo:
                </p>

                <figure>
                  <img src="img/public-filter.png" alt="excel" />
                </figure>

                <figcaption>Filtro Valor da Renda</figcaption>

                <p>
                  Clique em 'Filtrar' e aparecerá no mapa o resumo dos
                  resultados, com o total de perfis conforme os filtros, Persona
                  mais encontrada da região, média de idade e renda domiciliar
                  média do raio.
                </p>

                <figure>
                  <img src="img/resumo-resultados-mapa.png" alt="excel" />
                </figure>

                <figcaption>Resumo dos Resultados</figcaption>

                <p>
                  Agora salve o público potencial para usar em suas conexões de
                  audiência.
                </p>

                <br></br>
              </div>

              {/* Seção de votos */}

              <div>
                <PesquisaArtigo />
              </div>
            </div>

            <div className="col-md-3 text-left d-none d-md-inline-block">
              <MenuInicioRapido />
            </div>
          </div>
        </div>

        {showScrollButton && (
          <a onClick={scrollToTop} className="btn-topo">
            <a style={{ fontSize: "25px" }}>↑</a> Voltar ao Topo
          </a>
        )}
      </section>
      <Footer />
    </>
  );
}
